import { render, staticRenderFns } from "./FotoPerfil.vue?vue&type=template&id=79430655&scoped=true&"
import script from "./FotoPerfil.vue?vue&type=script&lang=js&"
export * from "./FotoPerfil.vue?vue&type=script&lang=js&"
import style0 from "./FotoPerfil.vue?vue&type=style&index=0&id=79430655&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79430655",
  null
  
)

export default component.exports